import 'phaser';

import { CBNGameConfig,GameType, PracPlay } from '../models/CBNGameModel';
import { Singleton } from '../tools/Singleton';
import { StartScene } from '../views/scenes/StartScene';
import { ScaleManager } from './ScaleManager';
import { EagleEyeExamGameModel } from '../models/EagleEyeExamGameModel';
import { TitleScene } from '../views/scenes/TitleScene';
import { SceneManager } from './SceneManager';
import { LocalizationManager } from './LocalizationManager';


export class GameManager extends Singleton{
    game:Phaser.Game|null = null;
    cbnGameConfig:CBNGameConfig|null = null;
    pracPlayOption:PracPlay;
    eagleEyeConfig:EagleEyeExamGameModel|null = null;
    buildConfig:any|null = null;
    initialClick:boolean|null = null;
    assetUrl:string|null = "";

    startGameEagleEyeExam(gameType:string, gameElement:HTMLDivElement, gameLevelComplete:(score:number,gameName:string, pracPlay:string)=>void, gameEndFunction: (score:number,gameName:string, pracPlay:string)=>void, gameData:any, pracPlay:string, htpShow:boolean, titleShow:boolean, previousScore:number, customTimeLimit:number|null, assetUrl:string="")
    {
        //Parse GameConfig
        this.cbnGameConfig = new CBNGameConfig((<any>GameType)[gameType],gameElement,gameData, (<any>PracPlay)[ pracPlay ],htpShow, titleShow,
            gameLevelComplete,gameEndFunction,previousScore, customTimeLimit);

        this.eagleEyeConfig = new EagleEyeExamGameModel(this.cbnGameConfig.gameData,50,3,false,20);
        let baseWidthInit = 1023;
        let baseHeightInit = 682;
        (<ScaleManager>ScaleManager.instance).baseWidth = baseWidthInit;
        (<ScaleManager>ScaleManager.instance).baseHeight = baseHeightInit;
        if(assetUrl) this.assetUrl = assetUrl; 

        var isMobile = {
            Android: function() {
                return navigator.userAgent.match(/Android/i);
            },
            BlackBerry: function() {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: function() {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            Opera: function() {
                return navigator.userAgent.match(/Opera Mini/i);
            },
            Windows: function() {
                return navigator.userAgent.match(/IEMobile/i);
            },
            any: function() {
                return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
            }
        };

        (<LocalizationManager>LocalizationManager.instance).setLocale(gameData.questions[0].language);

        let canvasType:any = null;
        if( isMobile.Android()) canvasType = Phaser.WEBGL;
        else canvasType = Phaser.CANVAS;


        this.initialClick = false;

        //End ClipInMindGameConfig Mock

        //Initialize Scenes
        let startScene = new StartScene({key:'StartScene'+Math.random()});
        
        //Initialize Game
        const config = { //:GameConfig
            type: canvasType,
            parent: gameElement,
            width: baseWidthInit,
            height: baseHeightInit,
            transparent: true,
            resolution: 1, 
            //backgroundColor: "#EDEEC9",
            scene: [
                startScene
            ],
            
        };
        this.game = new Phaser.Game(config);

        this.game.canvas.id  = 'game-canvas'
        // this.game.canvas.style.cssText = "width: 100vw; height: 100vh; background-color: #081f46; background-image: -webkit-radial-gradient(circle farthest-side at 100% 100%, rgba(85, 224, 198, .63), rgba(85, 224, 198, 0)), -webkit-radial-gradient(circle farthest-side at 0% 0%, rgba(91, 134, 229, .67), rgba(91, 134, 229, 0));background-image: radial-gradient(circle farthest-side at 100% 100%, rgba(85, 224, 198, .63), rgba(85, 224, 198, 0)), radial-gradient(circle farthest-side at 0% 0%, rgba(91, 134, 229, .67), rgba(91, 134, 229, 0));";
        // this.game.canvas.style.width = window.innerWidth+"";
        // this.game.canvas.style.height = window.innerHeight+"";
        this.game.canvas.style.width = gameElement.style.width+"";
        this.game.canvas.style.height = gameElement.style.height+"";
    }

    destroyGame(){
        console.log('Destroying Game!');
        window.onresize = null;

        setTimeout( () => {
            this.game!.destroy(true);
            console.log('Done Destorying Game');
        },500);
        
        //this.game!.destroy();
    }

    restartGame()
    {
        console.log("Restarting Game!")
        let nextScene = new TitleScene({key:'TitleScene'+Math.random()});

        let currentScene;
        
        for(let i = 0; i< this.game!.scene.scenes.length; i++)
        {
            if(this.game!.scene.isActive(this.game!.scene.scenes[i].scene.key))
            {
                if(currentScene != null) this.game!.scene.stop(currentScene.scene.key);
                currentScene = this.game!.scene.scenes[i];
            }
            else
            {
                this.game!.scene.stop(this.game!.scene.scenes[i].scene.key);
            }
            
        }
        
        SceneManager.changeScene(currentScene!,nextScene);
    }
}